import React, { FC, Suspense } from 'react';
import { Router } from 'react-router';
import { ThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { Loading } from '@minecraft.loader';
import { CoreTheme } from '@minecraft.themes';
import { NotificationProvider } from '@minecraft.notification-provider';
import { UserContextProvider } from '@blocs.auth';
import { FeatureExperimentProvider } from '@blocs.features-experiments';
import { MaintenanceGuard } from '@blocs.maintenance';
import { AppKey, InternationalizationProvider } from '@blocs.i18n';
import ImpactedServiceAlert from '@blocs.impacted-service-alert';
import Routes from 'src/routes';
import routerHistory from 'utils/router-history';
import createApolloClient from '../lib/createApolloClient';

const App: FC = () => {
  const apolloClient = createApolloClient();
  return (
    <Suspense fallback={<Loading />}>
      <InternationalizationProvider appName={AppKey.TALENT} namespaces={['talent']}>
        <FeatureExperimentProvider>
          <Router history={routerHistory}>
            <ApolloProvider client={apolloClient}>
              <UserContextProvider>
                <ThemeProvider theme={CoreTheme}>
                  <NotificationProvider>
                    <ImpactedServiceAlert />
                    <MaintenanceGuard routes={Routes} />
                  </NotificationProvider>
                </ThemeProvider>
              </UserContextProvider>
            </ApolloProvider>
          </Router>
        </FeatureExperimentProvider>
      </InternationalizationProvider>
    </Suspense>
  );
};

export default App;
